// Shared reading of the emergency release stored on a request, so the form,
// the request page and the printable record all agree on what it says.

export const isEmergencyRelease = (request) =>
  request?.requestType === "isEmergencyRelease";

// Reasons are stored as a list. Reads a single stored string too, so a
// release raised before the list existed still answers correctly rather
// than silently losing its waiver.
export const reasonsOf = (request) => {
  const stored =
    request?.emergencyRelease?.reasons || request?.emergencyRelease?.reason;

  if (!stored) return [];

  return Array.isArray(stored) ? stored : [stored];
};

// No sample means no crossmatch and no compatibility testing. Not a step the
// laboratory chose to skip but one that cannot be done at all, so the screens
// must not offer it.
export const hasNoSample = (request) =>
  isEmergencyRelease(request) && reasonsOf(request).includes("NO_SAMPLE");

export const skipsCrossmatch = (request) => {
  if (!isEmergencyRelease(request)) return false;
  if (hasNoSample(request)) return true;

  const ticked = request?.emergencyRelease?.components || [];

  return (
    ticked.includes("UNCROSSMATCHED_RBC") || ticked.includes("UNTESTED_PRODUCT")
  );
};

export const isEndorsed = (request) =>
  request?.emergencyRelease?.endorsement?.status === "endorsed";

